<template>
    <div>
      <!-- Added wrapper div for keyboard navigation and accessibility -->
      <!-- role="radiogroup" indicates this is a group of radio-button-like controls -->
      <!-- aria-label provides context for screen readers -->
      <div 
        class="star-rating-wrapper"
        role="radiogroup"
        aria-label="Rate from 1 to 5 stars"
        @keydown="handleKeydown"
        tabindex="0"
        ref="ratingWrapper"
      >
        <star-rating 
          :star-size="25"
          :border-color="borderColor"
          :inactive-color="'#fff'"
          :active-color="'orange'"
          :active-border-color="'orange'"
          :border-width="!this.value && this.validation.length > 0 ? 3 : 4"
          :show-rating="false"
          :rounded-corners="true"
          v-bind="$attrs"
          v-on="$listeners"
          v-model="inputVal"
          class="form-control"
          :class="{ 
            'is-valid': validation.length === 0 && value, 
            'is-invalid': validation.length > 0 
          }"
        />
      </div>
      <!-- Added role="alert" to validation message for accessibility -->
      <small 
        class="mt-1 text-danger" 
        v-if="validation.length > 0"
        role="alert"
      >
        {{ validation[0] }}
      </small>
    </div>
  </template>
  
  <script>
  import StarRating from 'vue-star-rating'
  
  export default {
    components: {
      StarRating,
    },
    
    props: ['value', 'validation'],
    computed: {
      inputVal: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      },
      borderColor() {
        return !this.value && this.validation.length > 0 
          ? 'rgba(220, 53, 69)' 
          : '#6c757d'
      }
    },
    methods: {
      // New method: Handles all keyboard interactions for blind People
      handleKeydown(event) {
        const currentValue = this.inputVal || 0;
        
        switch (event.key) {
          // Number keys 1-5 directly set the rating value
          case '1':
          case '2':
          case '3':
          case '4':
          case '5':
            this.inputVal = parseInt(event.key);
            break;
            
          // Left/Down arrows decrease rating
          // preventDefault() stops page scrolling
          case 'ArrowLeft':
          case 'ArrowDown':
            event.preventDefault();
            if (currentValue > 1) {
              this.inputVal = currentValue - 1;
            }
            break;
            
          // Right/Up arrows increase rating
          case 'ArrowRight':
          case 'ArrowUp':
            event.preventDefault();
            if (currentValue < 5) {
              this.inputVal = currentValue + 1;
            }
            break;
            
          // Home key sets to minimum rating (1)
          case 'Home':
            event.preventDefault();
            this.inputVal = 1;
            break;
            
          // End key sets to maximum rating (5)
          case 'End':
            event.preventDefault();
            this.inputVal = 5;
            break;
        }
      },
    },
    
    mounted() {
      console.log('v', this.validation);
    },
    
    watch: {
      validation(newVal) {
        console.log('v change', newVal);
      }
    }
  }
  </script>
  
  <style scoped>
  .form-control.vue-star-rating {
    border: none;
    margin-left: -3px;
    padding-left: 0;
  }
  /* New styles for keyboard focus handling */
  .star-rating-wrapper {
  display: inline-block;
  padding: 4px;
  border-radius: 4px;
  transition: box-shadow 0.3s ease;
  }

  </style>

<style>
/* Global focus styles for keyboard navigation only */
a[tabindex="0"]:focus-visible,
button[tabindex="0"]:focus-visible,
div[tabindex="0"]:focus-visible,
.star-rating-wrapper[tabindex="0"]:focus-visible {
  outline: 4px solid #007bff; /* Thick blue outline */
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.25); /* Subtle glow effect */
  transition: outline-color 0.2s ease-in-out;
}

/* Specific styles for the star rating wrapper with tabindex="0" */
.star-rating-wrapper[tabindex="0"]:focus-visible {
  outline-offset: 4px;
}

</style>